export interface SalesCenterWebhook {
  id?: number
  webhookType: string
  entityType: string
  endpointUrl: string
  isEnabled?: boolean
  customHeaderValues: CustomHeaderValue[]
  email: string
  createdTime?: string
}

export interface CustomHeaderValue {
  key: string
  value: string
  error: string
}

export type SalesCenterWebhookPageState = {
  page: number
  perPage: number
  orderBy: string
  selectedWebHook: SalesCenterWebhook | undefined
}

export interface SalesCenterWebhookModel {
  id?: number
  webhookType: string
  isEnabled?: boolean
  entityType: {
    lead: boolean
    opportunity: boolean
  }
  endpointUrl: string
  customHeaderValues: CustomHeaderValue[]
  email: string
}

export const salesCenterWebhookModel: SalesCenterWebhookModel = {
  webhookType: 'Status Change',
  isEnabled: true,
  entityType: {
    lead: false,
    opportunity: false,
  },
  endpointUrl: '',
  customHeaderValues: [
    {
      key: '',
      value: '',
      error: '',
    },
  ],
  email: '',
}
